import axios from '../axios';

const deleteInviteLink = async (projectId: string, _id: string) => {
  const { data } = await axios.delete(`/project-invites/${projectId}/${_id}`);

  return data;
};

export default deleteInviteLink;
